<template>
  <div class="avue-crud">
    <div class="page-content">
      <div class="table-box">
        <div class="table-header">
          <el-button
            class="tablebutton"
            icon="el-icon-plus"
            type="primary"
            size="small"
            @click="drawerSwitch('addDirectory')"
            >新 增</el-button
          >
          <el-button class="tablebutton" size="small" @click="foldTable(true)"
            >全部展开</el-button
          >
          <el-button class="tablebutton" size="small" @click="foldTable(false)"
            >全部折叠</el-button
          >
        </div>
        <el-table
          :data="tableData"
          row-key="id"
          default-expand-all
          ref="table"
          :empty-text="'暂无数据'"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          :header-cell-style="{ background: '#f5f7fa', color: '#333' }"
        >
          <el-table-column align="center" prop="id" label="编号" width="100" />
          <el-table-column align="center" prop="name" label="名称" />
          <el-table-column align="center" prop="permission" label="权限标识" />
          <el-table-column align="center" prop="url" label="链接" />
          <el-table-column align="center" label="图标" width="60" >
            <template #default="{ row }">
              <i :class="row.icon"></i>
            </template>
          </el-table-column>
          <el-table-column align="center" label="类型" width="80" >
            <template #default="{ row }">
              <span>{{
                row.type === 1 ? "目录" : "菜单"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="oindex"
            label="排序"
            width="80"
            align="center"
          />
          <el-table-column align="center" label="状态" width="100" >
            <template slot-scope="{ row }">
              <span
                :class="
                  row.disabled == 0
                    ? 'table-status-success'
                    : 'table-status-warn'
                "
                >{{ row.disabled == 0 ? "启用" : "禁用" }}</span
              >
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" fixed="right" width="300px">
            <template slot-scope="{ row }">
              <el-button
                type="text"
                size="mini"
                @click="drawerSwitch('edit', row)"
                >编辑</el-button
              >
              <el-button
                v-if="!row.children || row.children.length == 0"
                type="text"
                size="mini"
                @click="delTableData(row)"
                >删除</el-button
              >
              <el-button
                size="mini"
                type="text"
                @click="changeStatus(row, row.disabled)"
                >{{ row.disabled == 0 ? "禁用" : "启用" }}</el-button
              >
              <el-button
                size="mini"
                type="text"
                @click="drawerSwitch('add', row)"
                v-if="row.type == 1 || row.type == 2"
                >添加</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-drawer :visible.sync="drawerVisible" destroy-on-close size="500px">
      <div class="drawer-title" slot="title">菜单信息</div>
      <div class="drawer-content">
        <el-form
          class="drawer-form"
          :model="formData.menuForm"
          label-width="100px"
        >
          <el-form-item label="父级">
            <el-input v-model="formData.menuForm.parent" disabled></el-input>
          </el-form-item>
          <el-form-item label="名称" :required="true">
            <el-input
              v-model="formData.menuForm.name"
              clearable
              filterable
            ></el-input>
          </el-form-item>
          <el-form-item label="菜单类型" :required="true">
            <el-select
              v-model="formData.menuForm.type"
              clearable
              filterable
              placeholder="请选择菜单类型"
            >
              <el-option label="目录" value="1"></el-option>
              <el-option label="菜单" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="权限标识">
            <el-input
              v-model="formData.menuForm.permission"
              clearable
              filterable
            ></el-input>
          </el-form-item>
          <el-form-item label="链接" :required="true">
            <el-input
              v-model="formData.menuForm.url"
              clearable
              filterable
            ></el-input>
          </el-form-item>
          <el-form-item label="图标">
            <el-input
              v-model="formData.menuForm.icon"
              clearable
              filterable
            ></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              v-model="formData.menuForm.disabled"
              placeholder="请选择状态"
              clearable
              filterable
            >
              <el-option label="启用" value="0"></el-option>
              <el-option label="停用" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序">
            <el-input-number
              v-model="formData.menuForm.oindex"
            ></el-input-number>
          </el-form-item>
          <div class="drawer-footer">
            <el-button type="primary" @click="sendForm">确 定</el-button>
            <el-button @click="drawerSwitch">取 消</el-button>
          </div>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {fetchMenuTree, addObj, delObj, menuDisable} from '@/page/system/api/menu';

const menuForm = {
  id: "",
  parent: "无",
  pid: 0,
  name: "",
  icon: "",
  permission_id: "",
  disabled: 0,
  oindex: 1,
  showUrl: true,
  perminssion: "",
  type: null,
};
export default {
  name: "MenuManage",
  data() {
    return {
      formData: {
        menuForm: menuForm,
      },
      parentsMap: {},
      tableData: [],
      drawerVisible: false,

      delVisible: false,
      currentPage: 1,
      menuPath: [],
    };
  },
  mounted() {
    this.getMenuList();
  },
  methods: {
    // 菜单数据转换成表格所接受的数据格式
    listToTree(list) {
      let map = {},
        tree = [],
        parentsMap = {};
      for (let i = 0, len = list.length; i < len; i++) {
        list[i].children = []; // 为列表每个添加子集
        if (list[i].pid == 0) {
          // 一级菜单
          tree.push(list[i]);
          parentsMap[list[i].id] = list[i];
        } else {
          // 将所有非一级菜单用map记录索引关系
          if (map.hasOwnProperty(list[i].pid)) {
            map[list[i].pid].push(list[i]);
          } else {
            map[list[i].pid] = [list[i]];
          }
        }
      }
      for (let i = 0, len = tree.length; i < len; i++) {
        // 为一级菜单添加子级
        tree[i].children = map[tree[i].id];
      }
      this.parentsMap = parentsMap;
      return tree;
    },

    // 查询菜单列表
    getMenuList() {
      fetchMenuTree().then((res) => {
          if (res.data.success) {
            this.tableData = this.listToTree(res.data.data);
            console.log('tableData',this.tableData)
          }
        });
    },
    // 删除某个菜单
    delTableData(row) {
      this.$confirm("此操作将删除该项, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delObj(row.id).then((res) => {
            if (res.data.success) {
              this.$message({
                type: "success",
                message: `删除成功`,
              });
              this.getMenuList();
            }
          })
      });
    },
    // 修改菜单停用/启用状态, statusCase 1 - 禁用，0 - 启用
    changeStatus(row, statusCase) {
      let text = statusCase == 0 ? "禁用" : "启用";
      this.$confirm(`是否确定${text}？`, "提示", {
        confirmButtonText: text,
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        menuDisable({ id: row.id }).then((res) => {
            if (res.data.success) {
              this.$message({
                type: "success",
                message: `${text}成功`,
              });
              this.getMenuList();
            }
          })
      });
    },
    // 添加/编辑 表单提交
    sendForm() {
      console.log('this.formData', this.formData)
      addObj(this.formData.menuForm).then((res) => {
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.drawerVisible = false
          }
          this.getMenuList();
        })
      // this.drawerSwitch();
    },
    // 切换添加菜单表单状态
    drawerSwitch(type, row) {
      this.formData.menuForm = JSON.parse(JSON.stringify(menuForm));
      if (type && row) {
        let rowData = JSON.parse(JSON.stringify(row));
        console.log('rowData', rowData)
        if (type === "add") {
          // 为目录添加菜单
          this.formData.menuForm.parent = rowData.name;
          this.formData.menuForm.pid = rowData.id;
          this.formData.menuForm.showUrl = true;
        } else if (type === "edit") {
          // 菜单或目录编辑内容
          this.formData.menuForm = {
            id: rowData.id,
            parent: rowData.pname ? rowData.pname : "无",
            pid: rowData.pid,
            name: rowData.name,
            icon: rowData.icon || '',
            url: rowData.url,
            disabled: rowData.disabled,
            oindex: rowData.oindex,
            permission: rowData.permission,
            type: rowData.type,
          };
        }
      } else if (type === "addDirectory") {
        //添加目录
        this.formData.menuForm.parent = "无";
        this.formData.menuForm.showUrl = false;
      }
      this.drawerVisible = !this.drawerVisible;
    },
    // 表格展开折叠开关
    foldTable(foldcase) {
      let table = this.$refs.table;
      this.tableData.map((item) => {
        if (item.children && item.children.length > 0) {
          table.toggleRowExpansion(item, foldcase);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.el-form {
  width: 100%;
  padding: 0 40px 0 20px;
  box-sizing: border-box;

  .el-select {
    width: 100%;
  }
}
</style>
